import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from './FormGroup.module.scss';

interface FormGroupProps {
  className?: string;
}

export function FormGroup({ children, className }: PropsWithChildren<FormGroupProps>): React.JSX.Element {
  return <div className={classNames(styles.formGroup, className)}>{children}</div>;
}
